
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import TeamContactLinkItem from './TeamContactLinkItem'; // Import the TeamContactLinkItem component

const TeamContactLinkCategorySection = ({ categoryTitle, items, onContactLinkButtonClick, isLinkTypeRestricted, emailSignatureLinkTypes = [], isEmailSignatureMode = false }) => {
    const sortedItems = [...items].sort((a, b) => a.localeCompare(b));

    return (
        <Box sx={{ mb: 4 }}>
            {/* Category Title */}
            <Typography
                variant="body2"
                sx={{
                    fontSize: '0.75rem',
                    fontWeight: 'bold',

                    mb: 2, // Margin bottom for spacing
                    textAlign: 'left', // Left align the title
                }}
            >
                {categoryTitle}
            </Typography>

            {/* Buttons */}
            <Grid container spacing={1} sx={{ justifyContent: 'flex-start' }}>
                {sortedItems.map((item) => {
                    const isRestricted = isLinkTypeRestricted ? isLinkTypeRestricted(item) : false;
                    const isAlreadyAdded = isEmailSignatureMode && emailSignatureLinkTypes.includes(item);
                    const isMaxReached = isEmailSignatureMode && emailSignatureLinkTypes.length >= 6;
                    const isDisabled = isRestricted || isAlreadyAdded || (isMaxReached && !isAlreadyAdded);
                    return (
                    <Grid item xs={12} sm={4} md={3} key={item}>
                        <TeamContactLinkItem
                            text={item}
                            onClick={() => onContactLinkButtonClick(item)}
                            type={item}
                            disabled={isDisabled}
                        />
                    </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default TeamContactLinkCategorySection;